import { Link } from "@at/design-system-elements";
import { ThemeSelectors } from "@at/design-system-foundation";
import { BREAKPOINTS } from "@at/window-utils/lib/responsive-utils/match-media.util";
import styled, { css } from "styled-components";

import { MobilePadding } from "./advert-overview.styles";
import { PrintStyleSheet } from "../seller/advert-seller-details/location/location.styles";

export const VehicleInformation = styled.div`
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => ThemeSelectors.getLegacyGrey(theme)};
  padding: ${({ theme }) => ThemeSelectors.getLegacyGridUnit(theme) * 2}px 0;
  ${MobilePadding}
  ${PrintStyleSheet}
`;

export const StyledSpecButton = styled.div`
  border-bottom: 1px solid ${({ theme }) => ThemeSelectors.getGrey(theme)};
  padding: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
  ${PrintStyleSheet}
  @media screen and (min-width: ${BREAKPOINTS.MEDIUM}px) {
    padding: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)} 0;
  }

  & button.atds-button {
    margin-bottom: ${({ theme }) => ThemeSelectors.getGroupSixSpacing(theme)};
    @media screen and (max-width: ${BREAKPOINTS.MEDIUM}px) {
      width: 100%;
      margin-bottom: ${({ theme }) =>
        ThemeSelectors.getGroupFourSpacing(theme)};
    }
    @media screen and (min-width: ${BREAKPOINTS.MEDIUM}px) {
      margin: 0 0 ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
    }
  }
`;

export const VehicleInformationLink = styled(Link).attrs({
  renderAsButton: true,
})`
  ${({ theme }) => {
    return css`
      border: none;
      width: 100%;
      text-align: left;
      display: flex;
      align-items: center;

      &.is-disabled {
        div {
          cursor: not-allowed;
          color: ${ThemeSelectors.getCopyColor(theme)};
          &:hover,
          &:focus {
            fill: grey;
          }

          span {
            color: ${ThemeSelectors.getLegacyBlue(theme)};
          }

          svg {
            fill: grey;
            &:hover,
            &:focus {
              fill: grey;
            }
          }
        }
      }
    `;
  }}
  ${PrintStyleSheet}
`;
